/**
 * TKT-79640 — مرحله‌های «احراز هویت» و «انتخاب نقش» در ثبت دوره آموزشی
 * به‌صورت موقت غیرفعال شده‌اند تا هر کاربر واردشده بتواند دوره ثبت کند.
 *
 * برای فعال‌سازی مجدد، فقط مقدار گزینه‌های زیر را true کنید؛ هیچ کدی حذف نشده است:
 * - requireTrainerRole: پیش از ثبت دوره، نقش «مدرس» (TRAINER_USER) لازم باشد.
 * - requireIdentityVerification: پیش از ثبت دوره، احراز هویت (شهکار/کد ملی) لازم باشد.
 *
 * هم‌زمانی با فعال‌سازی، این نقاط هم باید فعال شوند:
 * 1) مسیر `/ads/course-ad` در `ads.routes.ts` — data.roles بر اساس همین فایل ست می‌شود.
 * 2) کارت «ثبت دوره آموزشی» در `ad/ad.component.ts` — از همین فایل استفاده می‌کند.
 * 3) بک‌اند: `@PreAuthorize("hasRole('TRAINER_USER')")` روی endpointهای مالک در
 *    `CourseAdController` (`/course-ad/save-my-draft`, `/{id}/submit`, ...) و
 *    کنترل احراز هویت شهکار برای نقش مدرس.
 */
export const COURSE_REGISTRATION_REQUIREMENTS = {
	/** انتخاب/داشتن نقش «مدرس» (TRAINER_USER) پیش از ثبت دوره. */
	requireTrainerRole: false,
	/** احراز هویت (شهکار / کد ملی) پیش از ثبت دوره. */
	requireIdentityVerification: false,
} as const

/** نقش بک‌اند/Keycloak مدرس دوره. */
export const TRAINER_ROLE = 'TRAINER_USER'

/**
 * نقش‌های لازم برای مسیر `/ads/course-ad` — منبع واحد برای ads.routes.ts.
 * آرایه خالی = هر کاربر واردشده (canActivateAuthRole با آرایه خالی فقط احراز ورود را چک می‌کند).
 */
export const COURSE_REGISTRATION_ROUTE_ROLES: string[] =
	COURSE_REGISTRATION_REQUIREMENTS.requireTrainerRole ? [TRAINER_ROLE] : []
